import { removeStore, getStore } from './../../assets/js/utils'
import { verifyToken } from "./../../assets/js/getData"
/** 
 * 用户信息管理
*/
const state = {
    userInfo: null, //用户信息
    loginPanelStatus: false, //登录弹窗状态
    loading: false 
}

const mutations = {
    //操作 -- 登录弹窗
    'LoginPanelStatus_Show': (state) => {
        state.loginPanelStatus = true
    },
    'LoginPanelStatus_Hide': (state) => {
        state.loginPanelStatus = false
    },
    //退出登录
    'OUT_LOGIN': ()=> {
        state.userInfo = null
        removeStore('uuid')
        removeStore("token")
        removeStore("nick_name")
        removeStore("picture")
        removeStore("vip")
    },

    //保存用户信息
    'SAVE_USERINFO': (state, info) => {
        state.userInfo = info
    },
    //操作 loading样式
    'Loading_Show': (state) => {
        state.loading = true
    },
    'Loading_Hide': (state) => {
        state.loading = false
    },
}

const getters = {}

const actions = {
    async getUserInfo({commit, state}) {
        let token = getStore('token');
        if (token) {
            let res = await verifyToken(token)
            commit("SAVE_USERINFO", res.data.data.user)
            state.userInfo = res.data.data.user
            return res
        }
    },
}


export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}
